import { useSyncExternalStore } from 'react';

// `idle`          — default/reset state; not in an error state.
// `unauthorized`  — an API call returned 401 "Invalid session"; triggers redirect to login.
type AuthStatus = `idle` | `unauthorized`;

class AuthStore {

    private _status: AuthStatus = `idle`;
    private _subscribers = new Set<() => void>();

    get token(): string | null {
        return localStorage.getItem(`authToken`);
    }

    get tokenExpiresAt(): string | null {
        return localStorage.getItem(`authTokenExpiresAt`);
    }

    get status(): AuthStatus {
        return this._status;
    }

    setUnauthorized() {
        if (this._status === `unauthorized`) return;
        this._status = `unauthorized`;
        this._notify();
    }

    setSession(token: string, expiresAt: string) {
        localStorage.setItem(`authToken`, token);
        localStorage.setItem(`authTokenExpiresAt`, expiresAt);
        this._status = `idle`;
        this._notify();
    }

    clearSession() {
        localStorage.removeItem(`authToken`);
        localStorage.removeItem(`authTokenExpiresAt`);
        this._status = `idle`;
        this._notify();
    }

    useStatus(): AuthStatus {
        return useSyncExternalStore(
            cb => {
                this._subscribers.add(cb);
                return () => this._subscribers.delete(cb);
            },
            () => this._status
        );
    }

    private _notify() {
        this._subscribers.forEach(sub => sub());
    }
}

export const authStore = new AuthStore();
